<div class="calendar" [style.--columns]="page().length || 1" [style.--hours]="hours().length">
  <div class="head">
    <div class="axis-head">
      @if (pages().length > 1) {
        <app-page-pie class="pager" [index]="pageIndex() % pages().length" [count]="pages().length" [seconds]="pageSecondsClamped()" />
      }
    </div>
    @for (column of page(); track column.key) {
      <div class="column-head" [class.today]="column.isToday && viewType() === 'WeekCalendar'">
        <span class="label">{{ column.label }}</span>
        @if (column.sublabel) {
          <span class="sublabel">{{ column.sublabel }}</span>
        }
      </div>
    }
  </div>

  <div class="grid">
    <div class="axis">
      @for (hour of hours(); track hour) {
        <div class="hour-label">{{ hour % labelEvery() === 0 ? hourLabel(hour) : '' }}</div>
      }
    </div>

    <div class="columns">
      @for (hour of hours(); track hour; let i = $index) {
        <div class="hour-line" [style.top.%]="(i / hours().length) * 100"></div>
      }

      @for (column of page(); track column.key) {
        <div class="column" [class.today]="column.isToday && viewType() === 'WeekCalendar'">
          @for (block of column.blocks; track block.period.id) {
            <div
              class="block"
              [class.blocked]="isBlocked(block.period)"
              [class.past]="block.past"
              [style.top.%]="block.top * 100"
              [style.height.%]="block.height * 100"
              [style.left.%]="(block.lane / block.lanes) * 100"
              [style.width.%]="100 / block.lanes"
              [class.overflow]="!!block.overflow"
              [class.narrow]="block.lanes >= narrowFromLanes"
            >
              @if (block.overflow) {
                <div class="more">+{{ block.overflow }}</div>
              } @else if (block.lanes >= narrowFromLanes) {
                <!-- Side by side with others, too narrow for the full box: the start and the activity. -->
                <div class="time">{{ block.startLabel }}</div>
                <div class="activity">
                  @if (isBlocked(block.period)) {
                    <svg class="blocked-icon" viewBox="0 0 31 30" aria-hidden="true"><path d="M2.33333 30C1.80556 29.8889 1.3125 29.6042 0.854167 29.1458C0.395833 28.6875 0.111111 28.1944 0 27.6667L27.6667 0C28.25 0.138889 28.75 0.423611 29.1667 0.854167C29.5833 1.28472 29.875 1.77778 30.0417 2.33333L2.33333 30ZM0 19.5V14.8333L14.8333 0H19.5L0 19.5ZM0 6.66667V3.33333C0 2.41667 0.326389 1.63194 0.979167 0.979167C1.63194 0.326389 2.41667 0 3.33333 0H6.66667L0 6.66667ZM23.3333 30L30 23.3333V26.6667C30 27.5833 29.6736 28.3681 29.0208 29.0208C28.3681 29.6736 27.5833 30 26.6667 30H23.3333ZM10.5 30L30 10.5V15.1667L15.1667 30H10.5Z" /></svg>Spærring
                  } @else {
                    {{ block.period.activity }}
                  }
                </div>
              } @else {
                <!-- The lines the screen is set up with, in its order. -->
                @for (field of cardFields(); track field) {
                  @switch (field) {
                    @case ('Time') {
                      <div class="time">{{ block.startLabel }}–{{ block.endLabel }}</div>
                    }
                    @case ('Activity') {
                      <div class="activity">
                        <!-- A blocking is never told by colour alone: the texture icon and the word too. -->
                        @if (isBlocked(block.period)) {
                          <svg class="blocked-icon" viewBox="0 0 31 30" aria-hidden="true"><path d="M2.33333 30C1.80556 29.8889 1.3125 29.6042 0.854167 29.1458C0.395833 28.6875 0.111111 28.1944 0 27.6667L27.6667 0C28.25 0.138889 28.75 0.423611 29.1667 0.854167C29.5833 1.28472 29.875 1.77778 30.0417 2.33333L2.33333 30ZM0 19.5V14.8333L14.8333 0H19.5L0 19.5ZM0 6.66667V3.33333C0 2.41667 0.326389 1.63194 0.979167 0.979167C1.63194 0.326389 2.41667 0 3.33333 0H6.66667L0 6.66667ZM23.3333 30L30 23.3333V26.6667C30 27.5833 29.6736 28.3681 29.0208 29.0208C28.3681 29.6736 27.5833 30 26.6667 30H23.3333ZM10.5 30L30 10.5V15.1667L15.1667 30H10.5Z" /></svg>Spærring
                        } @else {
                          {{ block.period.activity }}
                        }
                        @if (levelInline() && block.period.skillLevel) {
                          <span class="level">· {{ block.period.skillLevel }}</span>
                        }
                      </div>
                    }
                    @case ('Level') {
                      @if (!levelInline() && block.period.skillLevel) {
                        <div class="level">{{ block.period.skillLevel }}</div>
                      }
                    }
                    @case ('Facility') {
                      <div class="where">
                        {{ block.period.resourceParent ? block.period.resourceParent + ' / ' : '' }}{{ block.period.resource }}
                      </div>
                    }
                    @case ('Note') {
                      @if (block.period.title) {
                        <div class="title">{{ block.period.title }}</div>
                      }
                    }
                    @case ('LockerRooms') {
                      @for (room of block.period.lockerRooms; track room.id) {
                        <div class="room">{{ lockerRoomText(room) }}</div>
                      }
                    }
                  }
                }
              }
            </div>
          }

          @if (column.isToday && nowLine() !== null) {
            <div class="now-line" [style.top.%]="nowLine()! * 100"></div>
          }
        </div>
      } @empty {
        <div class="empty">Ingen aktiviteter</div>
      }
    </div>
  </div>
</div>
